export type WeblinkProjectLookupData = {
    projectUuid?: string | null;
    weblinkProjectName?: string | null;
};

export function getWeblinkProjectLookupName(data?: WeblinkProjectLookupData | null) {
    return data?.projectUuid?.trim() || data?.weblinkProjectName?.trim() || "";
}

export function getWeblinkOrderEffectiveEditability(allowsUserEditing: boolean | undefined, fileEditable: boolean | undefined): boolean {
    return allowsUserEditing ?? fileEditable ?? false;
}

export function getWeblinkOrderAllowsUserEditing(allowsUserEditing: boolean | undefined, ownerUsername?: string, currentUsername?: string): boolean {
    return allowsUserEditing === true || (!!ownerUsername && ownerUsername === currentUsername);
}

export function shouldOpenSharedOrderReadOnly(hasWeblinkOrder: boolean, ownedByCurrentUser?: boolean): boolean {
    return hasWeblinkOrder && ownedByCurrentUser === false;
}
